import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Container, Tab, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import Search from "./Search";
import Display from "./Display";
import Social from "./Social";
import Video from "./Video";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import {RouterContext} from "../Onboarding"

export default function AllCampaignGroups(props) {
  const route = useContext(RouterContext)

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem(
      "routerHistory",
      JSON.stringify([...route.get])
    );
  }, [route.get]);
  props.pageLocator();
  const [tabLocation, setTabLocation] = useState("");

  useEffect(() => {
    let searchParams = new URL(location.href).searchParams;
    let page = searchParams.get("page");
    if (!page || page == "") {
      page = "search";
    }
    setTabLocation(page);
  }, []);

  const selectTab = (key) => {
    setTabLocation(key);
  };

  return (
    <Container fluid className="px-5 collapse-padding-mobile">
      <Row className="mb-3 pb-3 justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Campaign Groups</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">
              On this page, you can set up any necessary campaign groups for your PPC services. Campaign groups are a great way to track the performance of
              specific areas of your business. Create campaign groups for each specific PPC sub-service as needed, and configure them below.{" "}
              <strong>
                Only the top three campaign groups will be displayed in the PPC Summary (indicated with a blue triangle in the bottom-right corner).{" "}
              </strong>
            </p>
          </div>
        </Col>
      </Row>
      <Row className="pb-2">
        <Col className="text-right">
          <NextButton
            validated={true} 
            btnText={`Next`}
            nextPage={nextPage.url}
            invalidText={`We need more information on this page before you continue.`}
            submitForm={props.submitForm}
          />
        </Col>
      </Row>
      <div className="mx-0 tab-shadow collapse-margin-mobile">
        <Tab.Container id="account-config-tabs" defaultActiveKey="search" activeKey={tabLocation} onSelect={(k) => selectTab(k)}>
          <Nav variant="pills" className="pt-0  pb-0 nav-fill tabs-navigation-2 row no-gutters row-cols-sm-1 row-cols-md-2 row-cols-lg-4 trim-padding">
            <Nav.Item className="col">
              <Nav.Link eventKey="search" className="tab-titles">
                Search
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="social" className="tab-titles">
                Social
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="display" className="tab-titles">
                Display
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="video" className="tab-titles">
                Video
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="search">
            {
                props.search_section.enabled ?
                <Search {...props} />
                :
                <div style={{ paddingLeft: "20px", backgroundColor: "#F5F5F5" }}>
                  <Row className="p-4">
                    <Col>
                      <div className="py-4">
                        <p>Search is not currently enabled</p>
                      </div>
                    </Col>
                 </Row>
                </div>
              }
            </Tab.Pane>
            <Tab.Pane eventKey="social">
            {
                props.social_section.enabled ?
                <Social {...props} />
                :
                <div style={{ paddingLeft: "20px", backgroundColor: "#F5F5F5" }}>
                  <Row className="p-4">
                    <Col>
                      <div className="py-4">
                        <p>Social is not currently enabled</p>
                      </div>
                    </Col>
                 </Row>
                </div>
              }
            </Tab.Pane>
            <Tab.Pane eventKey="display">
            {
                props.display_section.enabled ?
                <Display {...props} />
                :
                <div style={{ paddingLeft: "20px", backgroundColor: "#F5F5F5" }}>
                  <Row className="p-4">
                    <Col>
                      <div className="py-4">
                        <p>Display is not currently enabled</p>
                      </div>
                    </Col>
                 </Row>
                </div>
              }
            </Tab.Pane>
            <Tab.Pane eventKey="video">
            {
                props.video_section.enabled ?
                <Video {...props} />
                :
                <div style={{ paddingLeft: "20px", backgroundColor: "#F5F5F5" }}>
                  <Row className="p-4">
                    <Col>
                      <div className="py-4">
                        <p>Video is not currently enabled</p>
                      </div>
                    </Col>
                 </Row>
                </div>
              }
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
      <Row className="mt-5 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton 
                btnText={`Skip for now`}
                nextPage={nextPage.url}
              />
            <NextButton
              validated={true} 
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
